var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C11.4477 18 11 17.5523 11 17V9.46193L8.70167 11.733C8.31181 12.1514 7.68041 12.1507 7.29139 11.7314C7.09713 11.522 7 11.2478 7 10.9737C7 10.7446 7.0678 10.5156 7.20336 10.3244L7.29284 10.2145L9.59442 7.94027C10.2233 7.26381 11.0654 6.95231 11.8907 7.0059C11.9266 7.002 11.9631 7 12 7C12.037 7 12.0735 7.00201 12.1095 7.00592C12.9349 6.95222 13.7771 7.26371 14.4062 7.94027L16.7077 10.2145L16.7972 10.3244C16.9328 10.5156 17.0006 10.7446 17.0006 10.9737C17.0006 11.2478 16.9035 11.522 16.7092 11.7314C16.3202 12.1507 15.6888 12.1514 15.2989 11.733L13 9.46135V17C13 17.5523 12.5523 18 12 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.7d08ecdb2a4031619c912b4d0ddde788.svg";
export { ForwardRef as ReactComponent };